
import Vue from "vue";
import OnboardingHeader from "@/components/shared/onboarding/OnboardingHeader.vue";
import OnboardingFooter from "@/components/shared/onboarding/OnboardingFooter.vue";
import OnboardingDecoration from "@/components/shared/onboarding/OnboardingDecoration.vue";
import { mapGetters } from "vuex";
import { SITE_DIRECTION } from "@/store/modules/common/constants";
import { SiteDirections } from "@/store/modules/common/interfaces";

export default Vue.extend({
  name: "AuthenticationIndex",
  components: {
    // OnboardingDecoration,
    OnboardingHeader,
    OnboardingFooter
  },
  data() {
    return {
      currentSlide: 0,
      slides: [
        { src: "@/assets/images/muhwahib-dashboard.png", alt: "Dashboard Preview" },
        { src: "@/assets/images/dasboard-jobs.png", alt: "Jobs Dashboard Preview" },
        { src: "@/assets/images/dashboard-arabic.png", alt: "Arabic Dashboard Preview" }
      ],
      autoSlideInterval: null as any
    };
  },
  computed: {
    ...mapGetters("common", {
      get_site_direction: SITE_DIRECTION
    }),
    SiteDirections() {
      return SiteDirections;
    },
    sliderTransform() {
      const isRTL = this.get_site_direction === SiteDirections.RTL;
      const translateValue = (this as any).currentSlide * 33.333;
      return isRTL ? `translateX(${translateValue}%)` : `translateX(-${translateValue}%)`;
    }
  },
  mounted() {
    // Add a small delay to ensure images are loaded
    setTimeout(() => {
      (this as any).startAutoSlide();
    }, 1000);
  },
  beforeDestroy() {
    (this as any).stopAutoSlide();
  },
  methods: {
    nextSlide() {
      (this as any).currentSlide = ((this as any).currentSlide + 1) % (this as any).slides.length;
      console.log('Next slide:', (this as any).currentSlide);
    },
    previousSlide() {
      (this as any).currentSlide = (this as any).currentSlide === 0 ? (this as any).slides.length - 1 : (this as any).currentSlide - 1;
      console.log('Previous slide:', (this as any).currentSlide);
    },
    goToSlide(index: number) {
      (this as any).currentSlide = index;
      console.log('Go to slide:', (this as any).currentSlide);
    },
    startAutoSlide() {
      (this as any).autoSlideInterval = setInterval(() => {
        (this as any).nextSlide();
      }, 5000); // Change slide every 5 seconds
    },
    stopAutoSlide() {
      if ((this as any).autoSlideInterval) {
        clearInterval((this as any).autoSlideInterval);
        (this as any).autoSlideInterval = null;
      }
    }
  }
});
